"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _util = require("../../../util");
var _base = _interopRequireDefault(require("../../atomic/texts/base"));
(function () {
  if (typeof document === "undefined") {
    return;
  }
  var styles = ".pf-site-footer {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  background-color: #293c46;\n  color: #bbb;\n  font-size: 11px;\n  padding: 20px 16px 50px 16px;\n}\n.pf-site-footer a {\n  color: #bbb;\n  font-size: 12px;\n}\n.pf-site-footer__links {\n  list-style-type: none;\n  display: flex;\n  margin-top: 0;\n  margin-bottom: 10px;\n  padding-left: 0;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #bbb;\n}\n.pf-site-footer__links li + li::before {\n  content: \"|\";\n  padding-left: 4px;\n  padding-right: 4px;\n}\n.pf-site-footer__links a {\n  text-decoration: none;\n}\n.pf-site-footer__disclosures p {\n  margin-bottom: 10px;\n}";
  var fileName = "footer_styles_aea22bc8-81c8-47a8-a843-d62cd7a36465";
  var element = document.querySelector("style[data-sass-component='footer_styles_aea22bc8-81c8-47a8-a843-d62cd7a36465']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var BLOCK_CLASS = 'pf-site-footer';
var bem = (0, _util.klass)(BLOCK_CLASS);
var Footer = function Footer(_ref) {
  var links = _ref.links,
    disclosures = _ref.disclosures;
  return /*#__PURE__*/_react.default.createElement("footer", {
    className: BLOCK_CLASS
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: bem('links')
  }, links.map(function (link) {
    return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_base.default, {
      as: "a",
      href: link.href,
      target: "_blank"
    }, link.text));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: bem('disclosures')
  }, disclosures.map(function (disclosure) {
    return /*#__PURE__*/_react.default.createElement(_base.default, null, disclosure);
  })));
};
Footer.propTypes = {
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    href: _propTypes.default.string
  })).isRequired,
  disclosures: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
var _default = exports.default = Footer;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-select-plan-v2/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');